import type { ResultDetail } from '../../../../../../../../graphql/rest-link/types.ts';
import type { SubstitutionMap } from './types.ts';

type BuildAwardsSubstitutionsParams = {
  awards: ResultDetail['awards'];
  content: string;
};

const buildAwardsSubstitutions = ({
  awards,
  content,
}: BuildAwardsSubstitutionsParams): SubstitutionMap => {
  if (content.indexOf('%AWARDS%') < 0) {
    return {};
  }

  if (awards && awards.length > 0) {
    return {
      '%AWARDS%': awards
        .map<string>(
          ({ label, placeOrdinal }) =>
            `<span>${label}:</span>&nbsp;<strong>${placeOrdinal}</strong>`
        )
        .join('<br />'),
    };
  }

  return { '%AWARDS%': '' };
};

export default buildAwardsSubstitutions;
